import { Component, OnInit } from '@angular/core';
import { Co2SavingsService } from './co2-savings.service';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CulturalPipe } from '../../../../pipes/cultural.pipe';

@Component({
    selector: 'app-co2-savings',
    imports: [TranslatePipe, CulturalPipe],
    templateUrl: './co2-savings.html',
    styleUrl: './co2-savings.scss'
})
export class Co2Savings {
    
    constructor(
        public themeService: CustomizerSettingsService,
        private co2SavingsService: Co2SavingsService
    ) { }

    ngAfterViewInit(): void {
        this.co2SavingsService.loadChart();
    }

    ngOnDestroy(): void {
        this.co2SavingsService.destroyChart();
    }

}